import React from 'react';
import { Link } from 'react-router-dom';
import InstallButton from './InstallButton';

function Navigation() {
	return (
		<div className="navigation">
			<Link className="site-link" to="/">Home</Link>
			<InstallButton classNames="site-link" ctaText="Learn More" />
			<Link className="site-link" to="/shop">Shop</Link>
		</div>
	);
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Site/Navigation.js